import { useTranslation } from "react-i18next";
import { heroImageLeft, heroImageRight } from "../../../assets";
import StoreBadges from "../../../components/ui/StoreBadges";

function Hero() {
  const { t } = useTranslation();
  return (
    <div className="pt-16 lg:pt-32 pb-10 h-[100vh] md:h-[115vh] bg-black">
      <section id="hero">
        <div className="hero-container relative w-[90%] grid md:grid-cols-1 lg:grid-cols-3 gap-8 mx-auto">
          <img
            src={heroImageLeft}
            alt=""
            className="hidden md:hidden lg:block lg:w-full lg:max-h-[80vh] object-contain"
            loading="lazy"
          />

          <div className="hero-info flex flex-col justify-center items-center md:col-span-2 lg:col-span-1">
            <h1 className="text-5xl leading-none lg:text-[3.5rem] mt-16 font-euclid text-customGray text-center">
              {t("welcome")}
              <br />
            </h1>

            <p className="text-customGray text-5xl pt-4">
              <span className="text-customPurple-light">{t("try")}</span> {t("free")}
            </p>
            <div className="mt-4 md:mt-8 w-[70%]">
              <StoreBadges />
            </div>
            <p className="text-xl py-6 md:text-xl font-euclid text-customGray text-center">
              {t("aboutus")}
            </p>
          </div>

          <img
            src={heroImageRight}
            alt=""
            className="hidden md:hidden lg:block lg:w-full lg:max-h-[70vh] object-contain mt-0 md:mt-12 lg:mt-16"
            loading="lazy"
          />
        </div>
      </section>
    </div>
  );
}

export default Hero;
